
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rolex-certified-pre-owned",
      function () {
        return require("private-next-pages/rolex-certified-pre-owned/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rolex-certified-pre-owned"])
      });
    }
  